import React, { useRef } from 'react';
var VeltCommentBubbleUnreadIcon = function (props) {
    var defaultCondition = props.defaultCondition, annotationId = props.annotationId, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comment-bubble-unread-icon", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined, "annotation-id": annotationId }, children));
};
export default VeltCommentBubbleUnreadIcon;
